/** Platform admin: staff screen (P9, mockups/admin/staff.html). Reuses `admin.staff.*`; fil mirrors every key. */
export const staff = {
  notAvailable: "Not available yet",
  rowActions: "Actions for {{name}}",
  remind: "Remind",
  clearSearch: "Clear search",
  menu: {
    reset2fa: "Reset 2FA",
    signOut: "Sign out everywhere",
    remove: "Remove access",
  },
  invite: {
    meta: "Invited {{date}} · expires in {{count}} day",
    meta_other: "Invited {{date}} · expires in {{count}} days",
    pending: "Pending invite",
    resend: "Resend",
    revoke: "Revoke",
  },
  matrix: {
    subtitle: "Click a cell to toggle. Super Admin always has every permission. Changes are logged as",
    cellLabel: "{{permission}} for {{role}}: {{level}}",
    superAdminLocked: "Super Admin always has every permission",
    unsaved: "{{count}} unsaved change",
    unsaved_other: "{{count}} unsaved changes",
    resetDone: "Permissions reset to the saved matrix",
    save: "Save",
  },
} as const;
